import {MainRequest} from 'Services/common';
import {Mcp} from '../../service';

const UrlMap = {
    list: '/aichat/mcp/function/returns',
    edit: '/aichat/mcp/function/returns/saves',
    remove: '/aichat/mcp/function/returns/del',
};
export class McpFunctionReturns {
    static list(params: McpFunctionReturns.QueryList) {
        return MainRequest.get<SuccessData<McpFunctionReturns.List[]>>(
            `${UrlMap.list}/${params?.funcId}`,
            {
                params,
            },
        ).then(res => res.data.data);
    }

    static async save(data: McpFunctionReturns.Form) {
        return MainRequest.post(
            `${UrlMap.edit}/${data?.functionId}`,
            data?.formData,
        );
    }

    static async remove(id: string) {
        return MainRequest.get(`${UrlMap.remove}/${id}`);
    }
}

export namespace McpFunctionReturns {
    export type QueryForm = {};

    export interface Schema {
        id?: string;
        name: string; //        参数名称
        type: typeof Mcp.FieldType; //        参数类型：str, int, float, bool, json
        description: string; //        参数描述
        example: string; //        示例值
        required: boolean; //        是否必填：0-否，1-是
        sortOrder: number; //        排序顺序
    }

    export interface List extends Schema {}

    export interface Form {
        formData: Schema[];
        functionId: string;
    }

    export type QueryList = QueryForm & {funcId: string};
}
